"use client";
import React from 'react';
import homeSecond from '../images/bride3.jpg';
import homeMainRec from '../images/rsz_bride9.jpg';
import trioOne from '../images/bride1.jpg';
import trioTwo from '../images/bride4.jpg';
import raili3 from '../images/raili3.jpg';
import home3 from '../images/5D7A9378.jpg';
import trio3 from '../images/trio3.jpg';
import { Link} from 'react-router-dom';
import { useState, useLayoutEffect } from "react";

import slideshow4 from '../images/homeSlideshow/slideshow4.jpg';
import slideshow5 from '../images/homeSlideshow/slideshow5.jpg';
import slideshow8 from '../images/homeSlideshow/slideshow8.jpg';
import slideshow9 from '../images/homeSlideshow/slideshow9.jpg';
import slideshow10 from '../images/homeSlideshow/slideshow10.jpg';
import slideshow11 from '../images/homeSlideshow/slideshow11.jpg';
import slideshow12 from '../images/homeSlideshow/slideshow12.jpg';




const Home=() => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const slides = [
    {
        url: slideshow8
    },
    {
        url: slideshow9
    },
    {
        url: slideshow10
    },
    {
        url: slideshow4
    },
    {
        url: slideshow5
    },
    {
        url: slideshow11
    },
    {
        url: slideshow12
    }
]

useLayoutEffect(() => {
    const autoplay = setInterval(() => {
        nextSlide()
    }, 4000)

    return () => clearInterval(autoplay)
})

const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex === slides.length - 1 ? 0 : prevIndex + 1))
}

    return(
        <div className='home'>
            <div className='landing'>
            <img src={slides[currentIndex].url} alt='Bride spinning in her dress' className='homeImgMain'></img>
            <img src={homeMainRec} alt='Bride spinning in her dress' className='homeImgMainRec'></img>
            <div className='sloganButton'>
            <h1 className='slogan'>You've <span className='sloganEmph'>never</span> seen a dress like this before</h1>
            <Link to='/schedule' class='consultButton landingButton'>Book a Consultation</Link>
            </div>
            </div>
            <div className='mission'>
            <p className='missionStatement'>Here at Raili Custom Bridal we design one-of-a-kind couture wedding gowns through a fully custom, designer-led process, creating original pieces that exist nowhere else.</p>
            <img src={homeSecond} alt='Bride spinning in her dress' className='homeImgSecond'></img>
            </div>


            <div className='brideEx'>
                <div className='bridesExButton'>
            <p className='homeBrides'>Take a look at the beautiful dresses our brides have created with the help of Raili!</p>
            <Link to='/ourBrides' class='consultButton'>See our Brides</Link>
            </div>
            <img src={home3} alt='Bride spinning in her dress' className='carouselImg'></img>
            <div className='bridesTrio'>
                <img className='trioOne trio' src={trioOne} alt='Bride at the temple'></img>
                <img className='trioTwo trio' src={trioTwo} alt='Bride at the temple'></img>
                <img className='trioOne trio' src={trio3} alt='Bride at the temple'></img>
            </div>
            </div>

            <div className='aboutRaili'>
                <p className='aboutRailiTitle'>About the Designer</p>
                <p>"Someone once said 'if you want to be happy as an adult, try to remember what you loved doing as a seven-year-old and then do that.'' Well, when I was seven I loved drawing pretty girls in pretty dresses.</p>
                <p>I really have been so very blessed to be able to spend the last 40+ years doing just that, working with brides and selecting the most beautiful textiles to create one-of-a-kind custom wedding dresses. <em>This has really been a childhood dream come true.</em><em>" -Raili</em></p>
                <Link to='/aboutRaili' class='aboutButton'>Read more about Raili here!</Link>
            </div>

            <div className='consultation'>
            <img class='storefrontRec' src={raili3} alt='Storefront of Raili Custom Bridal'></img>
            <div className='consultationInfo'>
            <h2 class='consultHeader'>Book a Consultation</h2>
                        <img class='storefrontImg' src={raili3} alt='Storefront of Raili Custom Bridal'></img>

            <p class='consultPar'>I take on a limited number of custom commissions so every bride receives the attention she deserves. <em>Book here to start your custom bridal gown journey!</em></p>
            <Link to='/schedule' class='consultButton'>Book Here!</Link>
            </div>
            </div>
        </div>
    );
}

export default Home;